import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import api from '../../../../../services/api';

interface classComponentProps {
  classId: string;
}

interface ApiCourse {
  id: string;
  title: string;
  description: string;
  thumbnailUrl?: string;
}

interface ApiCourseData {
  course: ApiCourse[];
}

const ClassCourseList = ({ classId }: classComponentProps) => {
  const [courses, setCourse] = useState<ApiCourse[]>([]);

  useEffect(() => {
    async function requestCourse() {
      const { data } = await api.get<ApiCourse[]>(
        `/classes/${classId}/courses`,
      );
      setCourse(data);
    }
    requestCourse();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ClassCourseListContainer>
      {courses &&
        courses.map(course => (
          <Fragment key={course.id}>
            <StyledLink
              to={{
                pathname: '/dashboard/attend-course',
                state: {
                  courseId: course.id,
                  courseName: course.title,
                  courseDescription: course.description,
                },
              }}
            >
              <ThumbnailFrame>
                <Thumbnail
                  src={
                    course.thumbnailUrl
                      ? course.thumbnailUrl
                      : 'https://placehold.co/1920x1080?font=roboto&text=Curso'
                  }
                  alt="Lesson video thumbnail"
                />
              </ThumbnailFrame>
              <CourseTitle>{course.title}</CourseTitle>
              <CourseDescription>{course.description}</CourseDescription>
            </StyledLink>
          </Fragment>
        ))}
    </ClassCourseListContainer>
  );
};

export default ClassCourseList;

// Styled components

const ClassCourseListContainer = styled.section`
  padding: 2%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 10px;
  grid-auto-rows: auto;
  overflow: hidden;
  overflow-y: scroll;
  align-items: baseline;
`;

const StyledLink = styled(Link)`
  display: flex;
  flex-direction: column;
  width: 320px;
  color: #000;
  text-decoration: none;

  &:hover {
    transition: 0.1s;
    transform: scale(1.05);
  }
`;

const ThumbnailFrame = styled.div`
  align-self: center;
`;

const Thumbnail = styled.img`
  max-width: 320px;
  height: 180px;
  border-radius: 8px;
  margin-bottom: 8px;
`;

const CourseTitle = styled.h2`
  font-size: 1.563rem;
  text-transform: uppercase;
  font-family: 'Roboto', sans-serif;
`;

const CourseDescription = styled.p`
  margin-top: 8px;
  font-size: 1rem;
  overflow-y: hidden;
  font-family: 'Roboto', sans-serif;
`;
